import React, { useContext, useEffect, useRef, useState } from 'react'
import ArrowLeft from '../../components/icons/ArrowLeft'
import Step1 from '../../components/register/Step1'
import Step2 from '../../components/register/Step2'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { AuthContext } from '../../context/AuthContext'
import { updateUser } from '../../api/supabaseApi'

const step1Schema = yup.object().shape({
  fullName: yup.string().required('Full name is required'),
  dateOfBirth: yup.date().required('Date of Birth is required').nullable(),
  country: yup.string().required('Country is required'),
  age_range: yup.string().required('Age range is required'),
  organizationName: yup.string().required('Organization name is required'),
})

const step2Schema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .email('Invalid email format'),
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Password confirmation is required'),
})

const Register = () => {
  const {
    session: { user },
  } = useContext(AuthContext)
  const navigate = useNavigate()
  const [step, setStep] = useState(1)
  const [errorSignUp, setErrorSignUp] = useState(null)
  const progressBarRef = useRef(null)
  const countStep = 2
  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
    trigger,
    getValues,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      fullName: '',
      dateOfBirth: '',
      country: '',
      age_range: '',
      organizationName: '',
      email: '',
      password: '',
      passwordConfirmation: '',
    },
  })

  useEffect(() => {
    // TODO create avatar
    if (step >= 3) navigate('/')
    if (progressBarRef.current) {
      progressBarRef.current.style.width = `${(step / countStep) * 100}%`
    }
  }, [step])

  const validateStep = async () => {
    try {
      if (step === 1) {
        await step1Schema.validate(getValues(), { abortEarly: false })
      } else if (step === 2) {
        await step2Schema.validate(getValues(), { abortEarly: false })
      }
      return true
    } catch (err) {
      err.inner.forEach((validationError) => {
        setError(validationError.path, {
          type: 'manual',
          message: validationError.message,
        })
      })
      return false
    }
  }

  const handleNextStep = async () => {
    const isValid = await validateStep()
    if (isValid && step < countStep) {
      setStep(step + 1)
    }
  }

  const onSubmit = async (data) => {
    const isValid = await validateStep()
    if (isValid) {
      try {
        console.log(data)
        // await updateUser(user.id, data)
      } catch (error) {
        setErrorSignUp(error.message)
      }
    }
  }

  const renderByStep = () => {
    switch (step) {
      case 1:
      default:
        return (
          <Step1
            handleNextStep={handleNextStep}
            watch={watch}
            register={register}
            control={control}
            errors={errors}
          />
        )
      case 2:
        return (
          <Step2
            errorSignUp={errorSignUp}
            handleNextStep={handleNextStep}
            watch={watch}
            register={register}
            errors={errors}
          />
        )
    }
  }

  const preStep = () => {
    if (step === 1) {
      navigate(-1)
      return
    }
    setStep(step - 1)
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
      className="md:container mx-auto md:px-4 min-h-screen md:min-h-full"
    >
      <div className="bg-white p-6 w-full mx-auto rounded-lg shadow max-w-[648px]">
        <div className="flex justify-between gap-6 items-center mb-6">
          <a onClick={() => preStep()}>
            <ArrowLeft size="7" color="#212121" />
          </a>
          <div className="h-3 w-full relative bg-gray-200 rounded-lg">
            <div
              ref={progressBarRef}
              className="absolute bg-primary rounded-lg top-0 left-0 h-3"
            />
          </div>
          <div></div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>{renderByStep()}</form>
      </div>
    </motion.div>
  )
}

export default Register
